/* global globalThis */
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {View} from 'react-native';
import {createMaterialBottomTabNavigator} from 'react-native-paper/react-navigation';
import {Badge} from 'react-native-paper';

import MessagesScreen from '~/screens/messages';
import CalendarScreen from '~/screens/calendar';
import SearchScreen from '~/screens/search';
import withProtectedScreen from '~/components/hoc/with-protected-screen';

import {useSelector} from '~/lib/hooks';

import DateRangeIcon from '~/images/md-icons/date_range/materialicons/24px.svg';
import DateRangeOutlinedIcon from '~/images/md-icons/date_range/materialiconsoutlined/24px.svg';
import SearchIcon from '~/images/md-icons/search/materialicons/24px.svg';
import SearchOutlinedIcon from '~/images/md-icons/search/materialiconsoutlined/24px.svg';
import ChatIcon from '~/images/md-icons/chat/materialicons/24px.svg';
import ChatOutlinedIcon from '~/images/md-icons/chat/materialsymbolsoutlined/24px.svg';

const TabsStack = createMaterialBottomTabNavigator();

const TabMessagesIcon = ({focused, color}) => {
  const messages = useSelector((state) => state.messages);
  const unread = messages?.reduce(
    (acc, message) => acc + Number.parseInt(message.unread, 10),
    0,
  );

  useEffect(() => {
    const electronApi =
      globalThis.electronApi ?? globalThis.window?.electronApi;
    electronApi?.setBadgeCount?.(unread);
  }, [unread]);

  return (
    <View style={{width: 24, height: 24}}>
      {focused ? <ChatIcon fill={color} /> : <ChatOutlinedIcon fill={color} />}
      <Badge
        theme={{colors: {notification: '#B3261E'}}}
        visible={unread > 0}
        style={{position: 'absolute', top: 0, right: -2}}
        size={10}
      />
    </View>
  );
};

TabMessagesIcon.propTypes = {
  focused: PropTypes.bool,
  color: PropTypes.string,
};

const renderMessagesTabIcon = ({focused, color}) => (
  <TabMessagesIcon focused={focused} color={color} />
);
renderMessagesTabIcon.propTypes = {
  focused: PropTypes.bool,
  color: PropTypes.string,
};

const SearchTabIcon = ({focused, color}) => {
  if (focused) {
    return <SearchOutlinedIcon fill={color} />;
  }

  return <SearchIcon fill={color} />;
};
SearchTabIcon.propTypes = {
  focused: PropTypes.bool,
  color: PropTypes.string,
};

const CalendarTabIcon = ({focused, color}) => {
  if (focused) {
    return <DateRangeIcon fill={color} />;
  }

  return <DateRangeOutlinedIcon fill={color} />;
};
CalendarTabIcon.propTypes = {
  focused: PropTypes.bool,
  color: PropTypes.string,
};

const BottomTabs = ({route}) => {
  let {initialRouteName} = route.params ?? {};
  if (!initialRouteName) {
    // We don't have an initial route yet so we can't render the tabs
    return null;
  }

  return (
    <TabsStack.Navigator
      initialRouteName={initialRouteName}
      shifting={false}
      activeColor="#231fda"
      inactiveColor="#757575"
      barStyle={{
        backgroundColor: '#ffffff',
        borderTopColor: '#dcdcdc',
        borderTopWidth: 1,
      }}
      safeAreaInsets={{bottom: 0}}
      screenOptions={{
        headerShown: false,
      }}>
      <TabsStack.Screen
        name="Messages"
        options={{
          headerShown: false,
          title: 'Berichten',
          tabBarIcon: renderMessagesTabIcon,
        }}
        component={withProtectedScreen(MessagesScreen)}
      />
      <TabsStack.Screen
        name="Search"
        options={{
          title: 'Opdrachten',
          tabBarIcon: SearchTabIcon,
        }}
        component={withProtectedScreen(SearchScreen)}
      />
      <TabsStack.Screen
        name="Calendar"
        options={{
          title: 'Kalender',
          tabBarIcon: CalendarTabIcon,
        }}
        component={withProtectedScreen(CalendarScreen)}
      />
    </TabsStack.Navigator>
  );
};

BottomTabs.propTypes = {
  route: PropTypes.shape({
    params: PropTypes.shape({
      initialRouteName: PropTypes.string,
    }),
  }),
};

export default BottomTabs;
